import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { StartupServices } from '../constants/commonConstants';

@Injectable()
export class LoaderService {
  private services = [] as StartupServices[];

  public allServicesLoaded = new Subject<boolean>();
  public isLoading = new BehaviorSubject(false);
  public isLoadingForced = new BehaviorSubject(false);
  constructor() {}

  public registerService(service: StartupServices) {
    this.services.push(service);
  }

  public finishServiceLoad(service: StartupServices) {
    this.services = this.services.filter(x => x != service);

    if (this.services.length == 0) {
      this.allServicesLoaded.next(true);
      this.allServicesLoaded.complete();
    }
  }
}
